import {
  FIELDSET,
  ItemIds,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  LayoutColumnsDefinition,
  LayoutListDefinition,
  MESSAGE,
  MESSAGE_RESPONSE,
  TEXT,
  TEXT_MESSAGES,
  ADD_NEW_ITEM
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { ItemDefinition } from '~/training/sequence/templates/items/Item';
import { t } from 'ttag';
import { detectMultiSelect } from '~/training/sequence/templates/translators/itemHelpers/Quiz';
import { useEditorStore } from '~/shell/Store';

export const Quiz12: Translator = sequence => {
  const root = translate(sequence, () => null);
  const messages: ItemDefinition<ItemIds>[] = [];
  const rightPart: ItemDefinition<ItemIds>[] = [];

  let isContentEditable = false;
  try {
    const { contentEditable } = useEditorStore.getState();
    isContentEditable = !!contentEditable;
  } catch (e) {
    // ignore if store not available
  }

  sequence.items?.forEach(item => {
    if (item.__typename === 'List') {
      const elementItems = item?.items ? item.items : [];
      elementItems?.forEach(element => {
        const valuesData = element.title ? { sender: element.title } : {};

        messages.push({
          type: MESSAGE,
          id: element.id,
          start: 0,
          values: valuesData,
          items: [
            {
              type: TEXT,
              id: `${element.id}_body`,
              items: [],
              values: {
                value: element.body
              }
            }
          ]
        });
      });

      if (isContentEditable) {
        messages.push({
          type: ADD_NEW_ITEM,
          id: `_add_new_item`,
          items: [],
          values: {
            type: 'text'
          }
        });
      }
    }

    if (item.__typename == 'Question') {
      const elementItems = item?.items ? item.items : [];
      const _btn: ItemDefinition<ItemIds>[] = [];

      elementItems.forEach(element => {
        _btn.push({
          type: MESSAGE_RESPONSE,
          id: element.id,
          values: {
            correct: element.correct,
            feedback: element.feedback,
            feedbackAudios: element.feedbackAudios?.[0],
            group: `group_${element.id}_${item.id}`,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            llamaSurvey: item?.llamaSurvey,
            correctAnswers: detectMultiSelect(elementItems)
          },
          items: [
            {
              type: TEXT,
              id: `${element.id}_value`,
              items: [],
              values: {
                value: element.value,
                textAlignment: false
              }
            }
          ]
        });
      });

      messages.push({
        type: FIELDSET,
        id: 'FieldSetAndLegend',
        values: {
          title: t`Choose the correct answer(s)`
        },
        items: _btn
      });
    }

    if (item.__typename == 'Text') {
      rightPart.push(
        {
          type: TEXT,
          id: `${item.id}_subtitle`,
          items: [],
          values: {
            value: item.subtitle,
            variant: 'sub_heading',
            icon: item.icon
          }
        },
        {
          type: TEXT,
          id: `${item.id}_title`,
          items: [],
          values: {
            value: item.title,
            variant: 'heading1'
          }
        },
        {
          type: TEXT,
          id: `${item.id}_body`,
          items: [],
          values: {
            value: item.body
          }
        }
      );
    }
  });

  root.items.push({
    id: 'layout',
    type: LAYOUT_COLUMNS,
    items: [
      {
        type: TEXT_MESSAGES,
        id: '1',
        items: messages,
        values: {
          value: '',
          variant: 'llama',
          weNeedToUseOwnFeedback: true
        }
      },
      {
        id: 'right_part_with_text',
        type: LAYOUT_LIST,
        values: { align: { _: 'top', lg: 'left' } },
        orientation: 'row',
        items: rightPart
      } as LayoutListDefinition
    ]
  } as LayoutColumnsDefinition);

  return root;
};
